import React, { useRef, useLayoutEffect, useState }  from 'react'
import { IoMapOutline } from "react-icons/io5";
import { CiClock2 } from "react-icons/ci";
import { IoMailOutline } from "react-icons/io5";
import sea from "../Asset/resort/sea9.webp"
import $ from "jquery";
import { IoCall } from "react-icons/io5";

const Contectus = (props) => {
  const [show, setShow] = useState(false);
  const formRef = useRef(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [modalShow, setModalShow] = React.useState(false);

  // email
  const [custName, setCustName] = useState("");
  const [custEmail, setCustEmail] = useState("");
 
  const [custContact, setCustContact] = useState("");
  const [custSubject, setCustSubject] = useState("");
  const [custMessage, setCustMessage] = useState("");
 //////////
 

 const Appoinment = (e) => {
  var body =
      '<!DOCTYPE html><html> <head> <title>Sia Resort</title> <meta http-equiv="Content-Type" content="text/html; charset=utf-8"> <meta name="viewport" content="width=device-width,initial-scale=1"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> </head> <body style="margin:0!important;padding:0!important;background-color:#eee" bgcolor="#eeeeee"> <div style="display:none;font-size:1px;color:#fefefe;line-height:1px;font-family:Open Sans,Helvetica,Arial,sans-serif;max-height:0;max-width:0;opacity:0;overflow:hidden"></div><table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#fff"> <tr> <td align="center" style="background-color:#eee" bgcolor="#eeeeee"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"> <tr> <td align="center" valign="top" style="font-size:0;padding:10px" bgcolor="#FFD44C"> <div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:6px;font-weight:800;line-height:10px" class="mobile-center"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"> <tr> <td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;line-height:24px;padding:10px"> <a href="tel:+91 986745454" style="text-decoration:none;color:#000;font-family:serif;font-size:16px">Leade Generate for Sia Resort</a> </td></tr></table> </td></tr></table> </div></td></tr><tr> <td align="center" valign="top" style="font-size:0;padding:15px" bgcolor="#fff"> <div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"> <tr> <td align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:36px;font-weight:800;line-height:48px" class="mobile-center"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"> <tr> <td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-weight:800"> <img style="width:100%;height:120px" src="" alt=""> </td></tr></table> </td></tr></table> </div></td></tr><tr> <td align="center" valign="top" style="font-size:0;padding:0" bgcolor="#FFD44C"> <div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"> <tr> <td width="100%" align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;padding:10px 0" class="mobile-center"> <h1 style="text-transform:capitalize;font-size:14px;font-weight:500;margin:0;text-align:center;color:#000">Client Enquiry Details</h1> </td></tr></table> </div></td></tr><tr> <td align="center" height="100%" valign="top" width="100%" style="padding:0 35px 35px 35px;background-color:#fff" bgcolor="#eee"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:660px"> <tr> <td width="100%" align="center" valign="top" style="font-size:0"> <div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;text-align:center;width:100%"> <table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:300px"> <tr> <td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer Name:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custName +
      '</p></td></tr></table> </div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer Email:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custEmail +
      '</p></td></tr></table> </div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer contact:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custContact +
      '</p></td></tr></table> </div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer Message:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custMessage +
      '</p></td></tr></table> </div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer Subject:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custSubject +
     
      '</p></td></tr></table> </div></td></tr></table> </td></tr><tr> <td width="100%" align="center" bgcolor="#FFD44C" style="padding:10px 0"> <p style="color:#000;font-weight:500;font-size:1rem;padding:0;margin:0">Sia Resort</p></td></tr></table> </td></tr></table> </body></html> ';
  // console.log(custServices)
  $.post(
    "https://skdm.in/server/v1/send_lead_mail.php",
    {
      toEmail: "sales@siaresort.com",
      fromEmail: "skdmlead@gmail.com",
      bccMail: "skdmlead@gmail.com",
      mailSubject: "New Customer Lead",
      mailBody: body,
      accountName: "searesort",
      accountLeadSource: "https://canvasvilla.co.in/",
      accountLeadName: custName,
      // accountLeadEmail: custEmail,
    },
    function (dataa, status) {
      console.log("data :" + dataa);
      // console.log("name:" + custName);
      // console.log("name:" + custEmail);
      // console.log("name:" + custCheckIn);
    }
  );

  alert("Your Form has Submitted Our team will contact with You  soon.");
  e.preventDefault();
  return false;
};
  return (
    <div>
      <section
  className="breadcrumb-area d-flex align-items-center"
  style={{ backgroundImage:"url(https://r1imghtlak.ibcdn.com/58b6cb385c9311e7887d0a4cef95d023.jpg?downsize=1920:1080)",backgroundPosition:"center" }}
>
  <div className="container">
    <div className="row align-items-center">
      <div className="col-xl-12 col-lg-12">
        <div className="breadcrumb-wrap text-center">
          <div className="breadcrumb-title">
            <h2>Contact Us</h2>
            <div className="breadcrumb-wrap">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="index.html">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                  Contact Us
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section
  id="contact"
  className="contact-area after-none contact-bg pt-120 pb-120 p-relative fix"
>
  <div className="container">
    <div className="row justify-content-center align-items-center">
      <div className="col-lg-4 order-1">
        <div className="contact-info">
          <div
            className="single-cta pb-30 mb-30 wow fadeInUp  animated"
            data-animation="fadeInDown animated"
            data-delay=".2s"
            style={{ visibility: "visible", animationName: "fadeInUp" }}
          >
            <div className="f-cta-icon">
           
            <i className='far'>
            <IoMapOutline className='far' />
            </i>
         
            </div>
            <h5>Office Address</h5>
            <p>
            Survey 1915, Chintamani Galli (Lane),<br></br> Nagaon Beach Road,Nagaon, Alibag.<br />
            
            </p>
          </div>
          <div
            className="single-cta pb-30 mb-30 wow fadeInUp  animated"
            data-animation="fadeInDown animated"
            data-delay=".2s"
            style={{ visibility: "visible", animationName: "fadeInUp" }}
          >
            <div className="f-cta-icon">
                <i className='far'>
                <IoCall />
                </i>
            
          
            </div>
            <h5>contact us</h5>
            <p>
            +91-9404100001
            </p>
          </div>
          <div
            className="single-cta wow fadeInUp  animated"
            data-animation="fadeInDown animated"
            data-delay=".2s"
            style={{ visibility: "visible", animationName: "fadeInUp" }}
          >
            <div className="f-cta-icon">
                <i className='far'>
                <IoMailOutline />
                </i>
         
            </div>
            <h5>Message Us</h5>
            <p>
              {" "}
              <a href="#">sales@siaresort.com</a>
          
              
            </p>
          </div>
        </div>
      </div>
      <div className="col-lg-8 order-2">
        <div className="contact-bg02">
          <div
            className="section-title center-align mb-40 text-center wow fadeInDown  animated"
            data-animation="fadeInDown"
            data-delay=".4s"
            style={{ visibility: "visible", animationName: "fadeInDown" }}
          >
            <h2>Get In Touch</h2>
          </div>
          <form action="mail.php" method="post" className="contact-form mt-30"   ref={formRef}  {...props}>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="contact-field p-relative c-name mb-20">
                  <input
                    type="text"
                    id="firstn"
                    name="firstn"
                    placeholder="First Name"
                    required=""
                    onChange={(e) => setCustName(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="contact-field p-relative c-subject mb-20">
                  <input
                    type="text"
                    id="email"
                    name="email"
                    placeholder="Eamil"
                    required=""
                    onChange={(e) => setCustEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="contact-field p-relative c-subject mb-20">
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder="Phone No."
                    required=""
                    onChange={(e) => setCustContact(e.target.value)} 
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="contact-field p-relative c-subject mb-20">
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    placeholder="Subject"
                    onChange={(e) => setCustSubject(e.target.value)} 
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="contact-field p-relative c-message mb-30">
                  <textarea
                    name="message"
                    id="message"
                    cols={30}
                    rows={10}
                    placeholder="Write comments"
                    defaultValue={""}
                    onChange={(e) => setCustMessage(e.target.value)}
                  />
                </div>
                <div className="slider-btn">
                  <button
                    className="btn ss-btn"
                    data-animation="fadeInRight"
                    data-delay=".8s"
                    onClick={Appoinment} 
                  >
                    <span>Submit Now</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <p className='container' style={{textAlign:"justify"}}>
  Escape to the idyllic shores of Alibaug and indulge in the epitome of luxury at our exclusive Sia Resort. Nestled amidst the lush greenery, Sia Resort offers a serene retreat from the hustle and bustle of city life. As one of the premier resorts near Alibaug, we pride ourselves on providing unparalleled hospitality and a rejuvenating experience for our guests.

At Sia Resort, every aspect of your stay is meticulously crafted to ensure maximum comfort and satisfaction. Our spacious and elegantly appointed rooms offer breathtaking views of the surrounding landscape, providing the perfect setting for relaxation. Whether you choose to unwind by the poolside, take a leisurely stroll through our landscaped gardens, or pamper yourself at our spa, you'll find endless opportunities to rejuvenate your mind, body, and soul.

For the adventurous souls, Sia Resort offers a range of exciting activities, including water sports, trekking trails, and nature walks. Explore the pristine beaches of Alibaug or embark on a thrilling boat ride along the coastline – the possibilities are endless. And after a day of excitement, treat yourself to a delectable meal at our on-site restaurant, where our chefs expertly blend local flavors with international cuisines to tantalize your taste buds.

At Sia Resort, we understand the importance of creating lasting memories, which is why our team is dedicated to ensuring that every moment of your stay is nothing short of magical. Whether you're planning a romantic getaway, a family vacation, or a corporate retreat, Sia Resort promises an unforgettable experience that will leave you longing to return.

So why wait? Book your stay at Sia Resort today and discover why we're considered one of the top resorts near Alibaug. Escape the ordinary and embrace luxury at its finest – only at Sia Resort.








  </p>
</section>

    </div>
  )
}

export default Contectus
